import { firestore,storage } from "../firebase.js";

const state = {
    todosLosArticulos: [],
};

//
const mutations = {

    obtenerTodosLosArticulos(state, articulos) {
        state.todosLosArticulos = articulos;
    },
};

const actions = {

    async obtenerArticulos({ commit }) {
        const articulos = [];
        const articulosfirestore = await firestore.collection("articulos").get();
        articulosfirestore.docs.forEach((doc) => {
            const articulo = doc.data();
            articulo.id = doc.id;
            articulos.push(articulo);
        });
        commit("obtenerTodosLosArticulos", articulos);
        return articulos;
    },
};
const getters = {};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};